module.exports = __webpack_public_path__ + "img/icon-map-pin.b2664cfc.svg";